// @owners { team: patients }
import { get } from '~shared/helpers/apiHelper';
import { directAppStoreLink } from '~shared/helpers/helper';
import { useMutation } from '~shared/react-query';

/**
 * Fetch a deep app-download link for the given onboarding temp password.
 * Falls back to the platform's direct app-store link if the request fails,
 * so the resolved value is always a usable URL (never rejects).
 */
export const useFetchAppDownloadLink = () => {
  return useMutation({
    mutationFn: async (tempPassword: string): Promise<string> => {
      const response = await get('/users/app_onboard_link', { temp_password: tempPassword });
      if (response.error) {
        return directAppStoreLink();
      }
      // Fall back if a 2xx response is missing the url, so callers always get a usable link.
      return response.url ?? directAppStoreLink();
    },
  });
};
